import React from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import API from "../../Services/API";
import {toast} from "react-toastify";
import {IoDocuments} from "react-icons/io5";
import {LiaSignatureSolid} from "react-icons/lia";
import {useNavigate} from "react-router-dom";
import Footer from "../../Layouts/Footer";
import {TbDimensions} from "react-icons/tb";
import {PiMinusBold, PiPlusBold} from "react-icons/pi";
import {LuOctagonAlert} from "react-icons/lu";

function BookShip() {

    const navigate = useNavigate();


    const [isLoaded, setIsLoaded] = React.useState(false);
    const [id, setId] = React.useState(localStorage.getItem('did'));
    const [destination, setDestination] = React.useState([]);

    const [length, setLength] = React.useState([]);
    const [width, setWidth] = React.useState([]);
    const [height, setHeight] = React.useState([]);
    const [weight, setWeight] = React.useState([]);
    const [description, setDescription] = React.useState([]);
    const [isDocument, setIsDocument] = React.useState(0);
    const [needSign, setNeedSign] = React.useState(0);
    const [parcelCount, setParcelCount] = React.useState(1);
    const [from, setFrom] = React.useState({});
    const [to, setTo] = React.useState({});
    const [parcelValue, setParcelValue] = React.useState(0);
    const [insurance, setInsurance] = React.useState(0);
    const [date, setDate] = React.useState('');
    const [dc, setDC] = React.useState('');

    const [contentCount, setContentCount] = React.useState(1);
    const [loadContent, setLoadContent] = React.useState(1);
    const [content, setContent] = React.useState(null);

    const [descriptionC, setDescriptionC] = React.useState([]);
    const [country, setCountry] = React.useState([]);
    const [qty, setQty] = React.useState([]);
    const [unitWeight, setUnitWeight] = React.useState([]);
    const [unitValue, setUnitValue] = React.useState([]);
    const [reasons, setReasons] = React.useState([]);

    const [file1, setFile1] = React.useState(null);
    const [file2, setFile2] = React.useState(null);

    React.useEffect(() => {
        setLength(localStorage.getItem('_l').split(","));
        setWidth(localStorage.getItem('_w').split(","));
        setHeight(localStorage.getItem('_h').split(","));
        setWeight(localStorage.getItem('_we').split(","));
        setDescription(localStorage.getItem('_de').split(","));
        setIsDocument(parseInt(localStorage.getItem('_id')));
        setNeedSign(parseInt(localStorage.getItem('_ns')));
        setParcelCount(parseInt(localStorage.getItem('_c')));
        setParcelValue(parseInt(localStorage.getItem('_pv')));
        setInsurance(parseInt(localStorage.getItem('_in')));
        setDC(parseInt(localStorage.getItem('dc')));

        API.getDestination(localStorage.getItem('dc'))
            .then((response) => {
                setDestination(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                       // window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                       // window.history.back()
                    }, 400)
                }
            });


    }, []);




    const onStoreRequest = () => {

        if (!isDocument) {
            if (descriptionC.length < 1 ||country.length < 1 ||qty.length < 1 ||unitWeight.length < 1 ||unitValue.length < 1  ) {
                toast.error('Please Fill Shipment Content Information');
                return false;
            }
        }


        if (!from.name || !from.city || !from.state || !from.address1 || !from.address1|| !from.postalcode|| !from.phone || !from.contactName) {
            toast.error('Please Fill All Fields In Ship From');
            return false;
        }
        if (!to.name || !to.city || !to.address1 || !to.address1||  !to.phone|| !to.contactName) {
            toast.error('Please Fill All Fields In Ship To');
            return false;
        }

        if (!from.email) {
            toast.error('Please Fill Email Field');
            return false;
        }

        if (parcelValue < 1 && !isDocument) {
            toast.error('Please enter a valid number for parcel value');

            return false
        }
        if (!file1  || !file2) {
            toast.error('You need to upload photos before proceeding ');

            return false
        }



        const packageInfo = {
            lengths : length,
            width,
            height,
            weight,
            description
        }

        const shipmentContent = {
            'description' : descriptionC,
            country,
            qty,
            unitWeight,
            reasons,
            unitValue
        }
        const jsonData = {
            packageInfo,
            shipmentContent,
            weight,
            description,
            from,
            to

        };

// 2. فقط JSON و فایل‌ها را بفرستید
        const formData = new FormData();
        formData.append('data', JSON.stringify(jsonData));  // همه داده‌ها در یک فیلد
        formData.append('needSign', needSign);
        formData.append('isDocument', isDocument);
        formData.append('insurance', insurance);
        formData.append('id', id);
        formData.append('date', date);
        formData.append('parcelCount', parcelCount);
        formData.append('parcel_value', parcelValue);
        if (file1) formData.append('image1', file1);
        if (file2) formData.append('image2', file2);


        setIsLoaded(false);
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },100)
        API.saveRequest(formData)
            .then((response) => {
                localStorage.clear();
                setTimeout(() => {

                    const request = {
                        'request_id' : response.data.id
                    }
                    API.payment(request)
                        .then((response) => {

                            toast.success(response.message);
                             window.location.assign(response.url)

                        })
                        .catch((error) => {
                            setIsLoaded(true);
                            if (error.response) {
                                toast.error(error.response.data.message);
                            } else {
                                toast.error(error.message);
                            }
                        });

                }, 1300)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }


    const GenerateContent = () => {

        if ( weight[0] < 1) {
            return []
        }
        let rows = [];
        rows.push(<h5>
            Dimensions & Weights
            &nbsp;

        </h5>)
        for (let i = 0; i < parcelCount; i++) {
            rows.push(<div className="col-12 mt-3 pb-1" key={i}>
                <div className="row">
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Length"
                                   placeholder="Length"
                                   value={typeof length[i] !== 'undefined' ? length[i] : ''}
                                   disabled={true}
                            />
                            <label htmlFor="Length">Length (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Width"
                                   placeholder="Width"
                                   value={typeof width[i]  !== 'undefined' ? width[i] : ''}
                                   disabled={true}
                            />
                            <label htmlFor="Width">Width (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Height"
                                   placeholder="Height"
                                   value={typeof height[i] !== 'undefined' ? height[i] : ''}
                                   disabled={true}
                            />
                            <label htmlFor="Height">Height (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Weight"
                                   placeholder="Weight"
                                   value={typeof weight[i]  !== 'undefined' ? weight[i] : ''}
                                   disabled={true}
                            />
                            <label htmlFor="Weight">Weight (lb.):</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="Description"
                                   placeholder="Description"
                                   value={typeof description[i] !== 'undefined' ? description[i] : ''}
                                   disabled={true}
                            />
                            <label htmlFor="Description">Dimensional weight (lb.):</label>

                        </div>
                    </div>
                </div>
            </div>)
        }
        rows.push(
            <div className='row'>
                <div className="col-6 text-primary-emphasis text-start fw-bold my-3">
                    Parcel Value:
                    <div className="form-floating mb-3">
                        <input type="number" className="form-control" id="floatingInput"
                               placeholder="parcel"
                               required={true}
                               value={parcelValue}
                               disabled={true}
                        />
                        <label htmlFor="floatingInput">Value (CAD)</label>
                    </div>
                </div>
                <div className="col-6 my-3">
                    Insurance:
                    <div className="form-floating mb-3">
                        <input type="number" className="form-control" id="floatingInput"
                               placeholder="parcel"
                               value={insurance}
                               disabled={true}
                        />
                        <label htmlFor="floatingInput">Value (CAD)</label>
                    </div>
                </div>
            </div>
        )
        return (
            rows
        );

    }


    React.useEffect(() => {
        let rows = [];
        for (let i = 0; i < contentCount; i++) {

            rows.push(<div className="col-12 mt-3 border-bottom pb-2 " key={i}>
                <div className="row ">
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="Length"
                                   placeholder="Length"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       let l = descriptionC;
                                       l[i] = val.target.value
                                       setDescriptionC(l)

                                   }}
                            />
                            <label htmlFor="Length">Description: </label>
                            <p className='text-muted text-small-3'>
                                 e.g. Clothes, Multivitamin, Tablet,..
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <select name="r" id="r" className='form-control w-100 '
                                    onChange={(val) => {
                                        setLoadContent(loadContent + 1)
                                        let w = reasons;
                                        w[i] = val.target.value
                                        setReasons(w)
                                    }}
                            >
                                <option value="-">Reason For Export</option>
                                <option value="Commercially Sold Goods">Commercially Sold Goods</option>
                                <option value="Gift">Gift</option>
                                <option value="Repair/Warranty">Repair/Warranty</option>
                                <option value="Return Shipment">Return Shipment</option>
                                <option value="Commercial Sample">Commercial Sample</option>
                                <option value="Other">Other</option>
                            </select>

                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control text-small-2" id="Width"
                                   placeholder="Width"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       let w = country;
                                       w[i] = val.target.value
                                       setCountry(w)
                                   }}
                            />
                            <label htmlFor="Width">Country  Of Origin:</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Height"
                                   placeholder="Height"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       let h = qty;
                                       h[i] = val.target.value
                                       setQty(h)
                                   }}
                            />
                            <label htmlFor="Height">QTY:</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Weight"
                                   placeholder="Weight"
                                   onChange={(val) => {

                                       let we = unitWeight;
                                       we[i] = parseInt(val.target.value)
                                       setUnitWeight(we)
                                   }}
                            />
                            <label htmlFor="Weight">Total Weight (lb):</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="Description"
                                   placeholder="Description"


                                   onChange={(val) => {

                                       let d = unitValue;
                                       d[i] = val.target.value
                                       setUnitValue(d)
                                   }}
                            />
                            <label htmlFor="Description">Total Value (CAD):</label>
                        </div>
                    </div>
                </div>
            </div>)
        }
        setContent(rows);


    }, [contentCount,loadContent]);


    return (
        <React.Fragment>
            <Header/>

            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className='container '>
                <div className="row ">
                    <div className="col-md-7 pt-5 mt-5 ">

                        <p dangerouslySetInnerHTML={{__html: destination.about}}></p>
                    </div>
                    <div className="col-md-5 ">
                        <img src={destination.cover_image} alt={destination.title} className='w-100'/>
                    </div>

                </div>
            </section>


            <section className="container mt-4">
                <div className="row">
                    <div className="col-12">
                        <div className='fw-bold my-3'>
                            Shipment Information
                            (
                            <span className='mx-2 text-primary' role='button' onClick={() => {
                                navigate('/destination/' + localStorage.getItem('dc'))
                            }}>
                                Start Over
                            </span>
                            )
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card border-0">

                            <div className="card-body  not-active  p-4">
                                <div className="row border-bottom pb-4">
                                    <div className="col-md-6 text-big-2 text-center">
                                        <IoDocuments className='mx-2'/>
                                        Shipment Type :
                                        <strong className="text-success mx-2">
                                            {
                                                isDocument > 0 ?

                                                    'Document' :
                                                    'Package'
                                            }
                                        </strong>
                                    </div>
                                    <div className="col-md-6 text-big-2 text-center">
                                        <LiaSignatureSolid className='mx-2'/>
                                        Need Signature :
                                        <strong className="text-success mx-2">
                                            {
                                                needSign > 0 ?

                                                    'Yes' :
                                                    'No'
                                            }
                                        </strong>
                                    </div>
                                </div>

                                <div className="row mt-4">

                                    <div className="col-12">

                                        {GenerateContent()}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container mt-4">
                <div className="row">
                    <div className="col-12">
                        <div className="card border-0  not-active  p-4">
                            <div className="card-header">
                                Shipment Addresses
                            </div>
                            <div className="card-body ">
                                <div className="row border-bottom pb-4 ">

                                    <div className="col-md-6">
                                        <div className="row border-end ">
                                            <div className="col-12 my-3">
                                                <h5 className='fw-bold'>Ship From:</h5>
                                            </div>
                                            <div className=" col-md-12">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Name"
                                                           placeholder="Name"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.name = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Name">Name:</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Address1"
                                                           placeholder="Address1"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.address1 = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Address1"> Address 1:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Address2"
                                                           placeholder="Address2"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.address2 = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Address2"> Address 2 (Optional):</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Floor"
                                                           placeholder="Floor"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.floor = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Floor"> Unit / Floor (Optional):</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="ContactName"
                                                           placeholder="ContactName"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.contactName = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="ContactName"> Contact Name:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className="form-control" id="Phone"
                                                           placeholder="Phone"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.phone = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Phone"> Phone Number:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="PostalCode"
                                                           placeholder="PostalCode"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.postalcode = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="PostalCode"> Postal Code:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Counry"
                                                           placeholder="Counry"
                                                           value='Canada'
                                                           disabled={true}
                                                    />
                                                    <label htmlFor="Counry"> Country:</label>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="State1"
                                                           placeholder="State1"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.country = 'Canada'
                                                               f.state = val.target.value
                                                               setFrom(f)

                                                           }}
                                                    />
                                                    <label htmlFor="State1"> Province:</label>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="City1"
                                                           placeholder="City1"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.city = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="City1"> City:</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row border-end ">
                                            <div className="col-12 my-3">
                                                <h5 className='fw-bold text-success'>Ship To:</h5>
                                            </div>
                                            <div className=" col-md-12">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Name"
                                                           placeholder="Name"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.name = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="Name">Name:</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Address1"
                                                           placeholder="Address1"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.address1 = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="Address1"> Address 1:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Address2"
                                                           placeholder="Address2"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.address2 = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="Address2"> Address 2 (Optional):</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Floor"
                                                           placeholder="Floor"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.floor = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="Floor"> Unit / Floor (Optional):</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="ContactName"
                                                           placeholder="ContactName"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.contactName = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="ContactName"> Contact Name:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className="form-control" id="Phone"
                                                           placeholder="Phone"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.phone = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="Phone"> Phone Number:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="PostalCode"
                                                           placeholder="PostalCode"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.postalcode = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="PostalCode"> Postal Code:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="Counry"
                                                           placeholder="Counry"
                                                           value={destination.title}
                                                           disabled={true}
                                                    />
                                                    <label htmlFor="Counry"> Country:</label>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="State1"
                                                           placeholder="State1"
                                                           onChange={(val) => {
                                                               let t = to;
                                                               t.country = destination.title
                                                               t.state = val.target.value
                                                               setTo(t)

                                                           }}
                                                    />
                                                    <label htmlFor="State1"> Province:</label>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="City1"
                                                           placeholder="City1"
                                                           onChange={(val) => {
                                                               let t = to;

                                                               t.city = val.target.value
                                                               setTo(t)
                                                           }}
                                                    />
                                                    <label htmlFor="City1"> City:</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 mt-4">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="date" className="form-control" id="Date"
                                                           placeholder="Date"
                                                           min={new Date().toISOString().split('T')[0]}
                                                           onChange={(val) => {

                                                               setDate(val.target.value)
                                                           }}
                                                    />
                                                    <label htmlFor="Date"> Pick Up Date:</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating mb-3">
                                                    <input type="email" className="form-control" id="Email"
                                                           placeholder="Email"
                                                           onChange={(val) => {
                                                               let f = from;
                                                               f.email = val.target.value
                                                               setFrom(f)
                                                           }}
                                                    />
                                                    <label htmlFor="Email"> Email:</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {!isDocument &&

                <div className="container mt-3 card border-0 ">
                    <div className="row card-body not-active py-5 ">
                        <div className="col-12 my-3">
                            <h5 className='text-start'>
                                <TbDimensions className='mx-2 text-big-3 '/>
                                <strong className='mt-5'>
                                    Shipment Content Information
                                </strong>
                            </h5>

                        </div>
                        <div className='px-md-3 mt-0'>
                            <p className='text-small-2 '>
                                Please clearly provide the details of items in your package.<br/>
                            </p>
                            <div className='bg-white p-4 rounded '>
                                {
                                    content
                                }
                            </div>
                        </div>


                        <div className="col-12 text-start">
                            <button className='is-active px-4 mt-3 text-small-3'
                                    style={{borderStyle: 'solid'}}

                                    onClick={() => {
                                        setContentCount(contentCount + 1)
                                    }}
                            >
                                <PiPlusBold className='mx-2 text-big-2'/>
                                Add Item Row
                            </button>
                            <button className='not-active px-md-4 mx-md-3 mt-3 text-small-3'


                                    onClick={() => {
                                        if (contentCount > 1) {
                                            let w = descriptionC;
                                            w[contentCount - 1] = 0;
                                            setDescriptionC(w)
                                            let d = unitValue;
                                            d[contentCount - 1] = -1;
                                            setUnitValue(d)
                                            setContentCount(contentCount - 1)
                                        }
                                    }}
                            >
                                <PiMinusBold className='mx-2 text-big-2'/>
                                Remove Last Item
                            </button>
                        </div>
                    </div>

                </div>
            }

            <section className='container mt-3 mb-5 pb-5  not-active  '>
                <div className="row bg-light mt-4 p-md-3 ">

                    <div className="col-12">
                        <p className='p-2 text-small-1'>
                            <LuOctagonAlert className='mx-2' />
                            Please upload two photos showing the contents of your shipment inside the box and the package exterior.
                            
                            If you are shipping documents, upload photos of the envelope only.
                        </p>
                    </div>
                    <div className="col-md-6 ">
                        <input
                            type="file"
                            accept="image/*"

                            onChange={(e) => setFile1(e.target.files[0])}
                        />


                    </div>
                    <div className="col-md-6">
                        <input
                            type="file"
                            accept="image/*"

                            onChange={(e) => setFile2(e.target.files[0])}
                        />
                    </div>
                </div>
            </section>

            <section className='container mt-3 mb-5 pb-5  not-active  '>
                <div className="row bg-light mt-4 p-md-3 ">
                    <div className="col-md-8 ">
                    <div className="row mt-3 border-bottom pb-1 border-secondary">
                                        <div className="col-3  ">
                                            Services
                                        </div>
                                        <div className="col-3  ">
                                            Est. Transit
                                        </div>
                                        <div className="col-2 text-small-2 ">
                                            Shipping fee
                                        </div>
                                        <div className="col-2 text-small-2  ">
                                            GST/HST
                                        </div>
                                        <div className="col-2  ">
                                            Total
                                        </div>

                                    </div>
                                    <div className="row mt-3 mb-5">
                                        <div className="col-3  ">
                                            Air Freight
                                        </div>
                                        <div className="col-3  ">
                                            {destination.duration}
                                        </div>
                                        <div className="col-2  ">
                                            ${localStorage.getItem('_pr')} CAD
                                        </div>
                                        <div className="col-2  ">
                                            $0.00
                                        </div>
                                        <div className="col-2  fw-bold text-theme ">
                                            ${localStorage.getItem('_pr')} CAD
                                        </div>

                                    </div>
                                </div>


                                <div className="col-md-4 text-end">

                                    <button className="btn btn-primary  text-capitalize w-100 mt-4 "
                                            onClick={onStoreRequest}>

                                        Checkout
                                    </button>
                                    {/*<div className='text-small-2 text-center mt-4'>
                            By Clicking Checkout Button You Accept <span role='button' className='text-primary text-decoration-underline' onClick={() => {window.open('https://cheapship.ca/terms-conditions')}}>Term & Conditions</span>
                        </div>*/}
                                </div>

                                <dic className="col-md-6 mt-5">
                                    <p dangerouslySetInnerHTML={{__html: destination.description}}></p>
                                </dic>
                                <dic className="col-md-6">
                                    &nbsp;
                                </dic>
                            </div>

                        </section>
                        <Footer/>
        </React.Fragment>
);
}

export default BookShip;